export default "__VITE_ASSET__BpHkcP53__"